import React, { useState } from "react";
import useDocumentViewer from "../../../../../NewComponents/CustomViewDocumentHandler/CustomViewDocumentHandler";
import { useRouteMatch } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showModal } from "../../../../../redux/actions/modal";
import styles from "../FinancialInformation/Documents/AggregatorOnboardingReview.module.scss";
import CustomTextArea from "../../../../../NewComponents/CustomHTMLElements/CustomTextArea";
import { IFinancialDocumentsCategories } from "../FinancialInformation/Documents";
import CustomBadge from "../../../../Badge/badge";
import LoanDocumentsActionModal from "../../Components/DocumentsApprovalModal";
import { DownloadUploadedDocument } from "../../../../../NewComponents/UploadedDocumentCards/UploadedDocumentCard.component";
import { v4 as uuidv4 } from "uuid";
import { ReactComponent as MessageIcon } from "../../../../../assets/svg/icons/message-icon-2.svg";
import { ILoanInformation } from "../LoanInformation/util";
import useInvoiceDiscountingDocuments from "../../../../../custom-hooks/useInvoiceDiscountingDocuments";

const InvoiceDetailsDocuments = ({ data, refetchData }: ILoanInformation) => {
  const [actionData, setActionData] = useState({});
  const isRichText = true; // make richText true
  let currentInvoiceDetailId =
    data?.data?.data?.loan_application_details?.length > 0
      ? data?.data?.data?.loan_application_details[0]?.invoice_detail?.id
      : 0;
  const { handleViewDocument } = useDocumentViewer();

  const match = useRouteMatch();
  const dispatch = useDispatch();
  const {
    data: invoiceDiscountingDetailData,
    status: InvoiceDiscountingDetailStatus,
    isLoading: InvoiceDiscountingDetailIsLoading,
  } = useInvoiceDiscountingDocuments({
    invoice_detail_id: currentInvoiceDetailId,
  });
  const { id } = match.params as any;

  const handleViewComments = (
    e: any,
    existingComments: string,
    type: string,
    itemId: number,
    statusId: number,
    targetTypeId: number,
    isRichText?: boolean,
  ) => {
    e.preventDefault();
    dispatch(
      showModal({
        modalIdentifier: "rmloanapplicationcomments",
        dataRecord: {
          type,
          comments: existingComments,
          itemId,
          loanApplicationId: id,
          refetchData,
          statusId,
          targetTypeId,
          isRichText,
        },
      }),
    );
  };

  return (
    <div className="onboardingOuterLayout">
      <div className="onboardingInnerLayout">
        <div className="w-100">
          <div className={styles.uploadedDocsContainer}>
            {invoiceDiscountingDetailData &&
            invoiceDiscountingDetailData?.documents &&
            invoiceDiscountingDetailData?.documents?.length ? (
              <div>
                {invoiceDiscountingDetailData?.documents?.map(
                  (uploadedDocument: any, _id: number) => (
                    <div className="row mb-5" key={_id}>
                      <div className="col-12 d-flex justify-content-between">
                        <label className="form-label">
                          {_id + 1}. {uploadedDocument?.target_type}
                        </label>
                      </div>
                      <div className="col-12 d-flex">
                        <div>
                          {uploadedDocument?.files?.length < 1 ? (
                            <small className="text-center">
                              No documents uploaded for this category
                            </small>
                          ) : (
                            uploadedDocument?.files?.map((item: any) => (
                              <div className="d-flex" key={uuidv4()}>
                                <div
                                  className={`w-100 ${styles.downloadUploadDocContainer}`}
                                >
                                  <DownloadUploadedDocument
                                    name={item.file_name}
                                    pathname={item.upload_path}
                                    handleView={() =>
                                      handleViewDocument(
                                        false,
                                        item?.upload_path,
                                      )
                                    }
                                  />
                                  <CustomTextArea
                                    label="Description"
                                    readOnly
                                    defaultValue={item?.description}
                                  />
                                </div>
                              </div>
                            ))
                          )}
                          <div
                            className={`${styles.commentsAction} col-sm-4 col-md-4 col-lg-4 `}
                            onClick={(e) => {
                              if (
                                uploadedDocument?.target_type_id ===
                                IFinancialDocumentsCategories.AdditionalDocuments
                              ) {
                                handleViewComments(
                                  e,
                                  uploadedDocument?.comment,
                                  "invoice_discounting",
                                  uploadedDocument?.id,
                                  invoiceDiscountingDetailData?.loan_application_detail_id,
                                  uploadedDocument?.target_type_id,
                                  isRichText,
                                );
                              } else {
                                handleViewComments(
                                  e,
                                  uploadedDocument?.comment,
                                  "invoice_discounting",
                                  uploadedDocument?.id,
                                  invoiceDiscountingDetailData?.loan_application_detail_id,
                                  uploadedDocument?.target_type_id,
                                );
                              }
                            }}
                          >
                            <MessageIcon className={styles.messageIcon} />
                            <span className={styles.commentText}>Comment</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            ) : (
              <div className="w-100 d-flex align-items-center justify-content-center py-3">
                <h3 className="font-weight-bold">
                  Customer is yet to upload Invoice Discounting documents
                </h3>
              </div>
            )}
          </div>
        </div>
      </div>
      <LoanDocumentsActionModal data={actionData} refetchData={refetchData} />
    </div>
  );
};

export default InvoiceDetailsDocuments;
